/** @format */

export const QUERY_KEYS = {
  service: "service",
  certificate: "certificate",
  profile: "profile",
  education: "education",
  experience: "experience",
  skill: "skill",
  company: "company",
} as const;
